/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ decade: NonNullable<unknown> }} Hof_Decade_LabelInputs */

const en_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}s`)
};

const es_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Década de ${i?.decade}`)
};

const de_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}er`)
};

const zh_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}年代`)
};

const ar_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عقد ${i?.decade}`)
};

const fr_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Années ${i?.decade}`)
};

const vi_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thập niên ${i?.decade}`)
};

const sw_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miaka ya ${i?.decade}`)
};

const th_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทศวรรษ ${i?.decade}`)
};

const bs_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-ih`)
};

const ja_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}年代`)
};

const ko_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}년대`)
};

const pt_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anos ${i?.decade}`)
};

const it_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anni ${i?.decade}`)
};

const sv_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-talet`)
};

const nl_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jaren ${i?.decade}`)
};

const da_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}'erne`)
};

const nb_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-tallet`)
};

const fi_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-luku`)
};

const pl_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lata ${i?.decade}.`)
};

const ru_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-е`)
};

const tr_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}'ler`)
};

const hi_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade} का दशक`)
};

const id_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-an`)
};

const ms_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-an`)
};

const cs_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}. léta`)
};

const el_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Δεκαετία του ${i?.decade}`)
};

const he_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`שנות ה-${i?.decade}`)
};

const af_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}'s`)
};

const hu_hof_decade_label = /** @type {(inputs: Hof_Decade_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.decade}-as évek`)
};

/**
* | output |
* | --- |
* | "{decade}s" |
*
* @param {Hof_Decade_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_decade_label = /** @type {((inputs: Hof_Decade_LabelInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Decade_LabelInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_decade_label(inputs)
	if (locale === "de") return de_hof_decade_label(inputs)
	if (locale === "zh") return zh_hof_decade_label(inputs)
	if (locale === "ar") return ar_hof_decade_label(inputs)
	if (locale === "fr") return fr_hof_decade_label(inputs)
	if (locale === "vi") return vi_hof_decade_label(inputs)
	if (locale === "sw") return sw_hof_decade_label(inputs)
	if (locale === "th") return th_hof_decade_label(inputs)
	if (locale === "bs") return bs_hof_decade_label(inputs)
	if (locale === "ja") return ja_hof_decade_label(inputs)
	if (locale === "ko") return ko_hof_decade_label(inputs)
	if (locale === "pt") return pt_hof_decade_label(inputs)
	if (locale === "it") return it_hof_decade_label(inputs)
	if (locale === "sv") return sv_hof_decade_label(inputs)
	if (locale === "nl") return nl_hof_decade_label(inputs)
	if (locale === "da") return da_hof_decade_label(inputs)
	if (locale === "nb") return nb_hof_decade_label(inputs)
	if (locale === "fi") return fi_hof_decade_label(inputs)
	if (locale === "pl") return pl_hof_decade_label(inputs)
	if (locale === "ru") return ru_hof_decade_label(inputs)
	if (locale === "tr") return tr_hof_decade_label(inputs)
	if (locale === "hi") return hi_hof_decade_label(inputs)
	if (locale === "id") return id_hof_decade_label(inputs)
	if (locale === "ms") return ms_hof_decade_label(inputs)
	if (locale === "cs") return cs_hof_decade_label(inputs)
	if (locale === "el") return el_hof_decade_label(inputs)
	if (locale === "he") return he_hof_decade_label(inputs)
	if (locale === "af") return af_hof_decade_label(inputs)
	if (locale === "hu") return hu_hof_decade_label(inputs)
	return en_hof_decade_label(inputs)
});